import React, { useState, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import "./Css/search.css";

import { Outlet, useNavigate } from "react-router-dom";

function SearchBar() {
  const [query, setQuery] = useState("");
  const { baseUrl, gameList, setgamelist } = useContext(AppContext);
  const [result, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // setResults(data);
    try {
      setShowDropdown(false);
      if (!query) {
        setResults([]);
        setgamelist([]);
      }
      const response = await axios.get(`${baseUrl}/search?search=${query}`);
      if (response) {
        //setResults(response.data.data);
        const searchganelist = response.data.data;
        if (searchganelist.length > 0) {
          setResults(searchganelist);
          setgamelist(searchganelist);
          setShowDropdown(false);
          setQuery("");
          navigate(`/search/${query}-games`);
        } else {
          setResults([]);
          setgamelist([]);
          setShowDropdown(false);
          setQuery("");
        }

        //setResults(data);
        //setCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
    
  };

  const handleSearch = async () => {
   
    try {
      const response = await axios.get(`${baseUrl}/search?search=${query}`);
      if (response && response.data) {
        const searchganelist = response.data.data || []; // fallback to []

        if (Array.isArray(searchganelist) && searchganelist.length > 0) {
          
          setResults(searchganelist);
          setgamelist(searchganelist);
          setShowDropdown(true);
          setQuery("");
          navigate(`/search/${query}-games`);
        } else {
          setResults([]);
          setgamelist([]);
          setShowDropdown(false);
          setQuery("");
        }
      }
    } catch (error) {
      console.error("Error during search:", error);
      setResults([]);
      setShowDropdown(false);
    }
  };

  return (
    <div className="search-container">
      <form onSubmit={handleSubmit} autoComplete="off" className="search-form">
        <input
          type="text"
          placeholder="Search games..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="search-input"
        />
        <button type="submit" className="search-button">
          Search
        </button>
      </form>

      {showDropdown && result.length > 0 && (
        <div className="dropdown main_dropdown">
          {result.map((game, idx) => (
            <div
              key={idx}
              className="dropdown-item"
              onClick={() => {
                setQuery(game.game_title);
                setShowDropdown(false);
              }}
            >
              <p style={{ cursor: "pointer" }} className="title">
                {game.game_title}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchBar;
